/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';
import type { InternalUserResponse } from './InternalUserResponse';
import {
    InternalUserResponseFromJSON,
    InternalUserResponseFromJSONTyped,
    InternalUserResponseToJSON,
    InternalUserResponseToJSONTyped,
} from './InternalUserResponse';

/**
 * 
 * @export
 * @interface InternalUserResponsePagedResult
 */
export interface InternalUserResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof InternalUserResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<InternalUserResponse>}
     * @memberof InternalUserResponsePagedResult
     */
    data: Array<InternalUserResponse> | null;
}

/**
 * Check if a given object implements the InternalUserResponsePagedResult interface.
 */
export function instanceOfInternalUserResponsePagedResult(value: object): value is InternalUserResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function InternalUserResponsePagedResultFromJSON(json: any): InternalUserResponsePagedResult {
    return InternalUserResponsePagedResultFromJSONTyped(json, false);
}

export function InternalUserResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalUserResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(InternalUserResponseFromJSON)),
    };
}

export function InternalUserResponsePagedResultToJSON(json: any): InternalUserResponsePagedResult {
    return InternalUserResponsePagedResultToJSONTyped(json, false);
}

export function InternalUserResponsePagedResultToJSONTyped(value?: InternalUserResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(InternalUserResponseToJSON)),
    };
}

